module.exports = __webpack_public_path__ + "img/002.8d6b92d5.png";